import StoredLayout from '../../layouts/StoredLayout'
import TimelineWidgets from './TimelineWidgets'
export default StoredLayout(TimelineWidgets)



// WEBPACK FOOTER //
// ./src/widgets/timeline-widgets/index.js